import styled from 'styled-components';
import hexToRgba from 'hex-rgba';

import { getStyle as iconControlMediumStyles } from '@ids/ddms-styled/comps/iconControlMd/intuit/light';
import { getStyle as iconControlSmallStyles } from '@ids/ddms-styled/comps/iconControlSm/intuit/light';
import { getStyle as iconControlSmallStylesDark } from '@ids/ddms-styled/comps/iconControlSm/intuit/dark';
import { getStyle as iconControlLargeStyles } from '@ids/ddms-styled/comps/iconControlLg/intuit/light';

// Button Sizes.
const buttonSize = {
  small: iconControlSmallStyles('background.height'),
  medium: iconControlMediumStyles('background.height'),
  large: '44px'
};

// The below should be added/retrieved from DDS.  Need to work with XDs
const iconLabel = {
  size: {
    small: '12px',
    medium: '14px',
    large: '16px'
  },
  margin: {
    small: '4px',
    medium: '4px',
    large: '8px'
  },
  position: {
    top: 'column-reverse',
    bottom: 'column',
    right: 'row',
    left: 'row-reverse'
  }
};

// Focus styles for light and dark theme
const focus = {
  light: {
    stroke: hexToRgba(
      iconControlMediumStyles('highlight.color'),
      iconControlMediumStyles('highlight.opacity')
    )
  },
  dark: {
    stroke: hexToRgba(
      iconControlSmallStylesDark('highlight.color'),
      iconControlSmallStylesDark('highlight.opacity')
    )
  }
};

// Background colors
const background = {
  light: {
    default: hexToRgba(
      iconControlMediumStyles('icon.color'),
      iconControlMediumStyles('overlay.opacity')
    ),
    hover: hexToRgba(
      iconControlMediumStyles('icon.color.hover'),
      iconControlMediumStyles('overlay.opacity.hover')
    ),
    active: hexToRgba(
      iconControlMediumStyles('icon.color.active'),
      iconControlMediumStyles('overlay.opacity.active')
    ),
    selected: hexToRgba(
      iconControlMediumStyles('icon.color.selected'),
      iconControlMediumStyles('overlay.opacity.active')
    )
  },
  dark: {
    default: hexToRgba(
      iconControlMediumStyles('icon.color'),
      iconControlMediumStyles('overlay.opacity')
    ),
    hover: hexToRgba(
      iconControlMediumStyles('icon.color.hover'),
      iconControlMediumStyles('overlay.opacity.hover')
    ),
    active: hexToRgba(
      iconControlMediumStyles('icon.color.active'),
      iconControlMediumStyles('overlay.opacity.active')
    ),
    selected: hexToRgba(
      iconControlSmallStylesDark('overlay.color'),
      iconControlSmallStylesDark('overlay.opacity.active')
    )
  }
};

// Styles for Label
export const Label = styled.span`
  color: ${props =>
    props.color && props.color.default ? props.color.default : '#6b6c72'};
  font-weight: 500;
  ${props => props.size && `margin: ${iconLabel.margin[props.size]};`}
  ${props => props.size && `font-size: ${iconLabel.size[props.size]};`}
  ${props =>
    props.selected &&
    `
    color: ${
      props.color && props.color.selected
        ? props.color.selected
        : iconControlLargeStyles('icon.color.selected')
    };
  `}
  ${props =>
    props.inverse &&
    `color: ${iconControlSmallStylesDark('icon.color.selected')};`}
`;

export const Button = styled.button`
  font-family: inherit;
  cursor: pointer;
  box-shadow: none;
  padding: 0;
  border: 0 solid transparent;
  outline: none;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  background-color: ${background.light.default};
  vertical-align: middle;
  ${props =>
    props.size && !props.label && `height: ${buttonSize[props.size]};`};
  ${props => props.size && !props.label && `width: ${buttonSize[props.size]};`};
  ${props =>
    !props.selected &&
    `
  &:hover {
    background-color: ${
      props.hoverColor ? props.hoverColor : background.light.hover
    };
  }
  &:active {
    background-color: ${background.light.active};
  }`}

  ${props =>
    props.inverse &&
    !props.selected &&
    `
  background-color: '${background.dark.default}';
  &:hover {
    background-color: ${background.dark.hover};
  }
  &:active {
    background-color: ${background.dark.active};
  }`}
  ${props =>
    props.selected &&
    `
    background-color: ${
      props.selectedBackgroundColor
        ? props.selectedBackgroundColor
        : background.light.selected
    };
  `}
  ${props =>
    props.a11yFocus &&
    `
    box-shadow: 0 0 0 2px ${
      props.focusColor ? props.focusColor : focus.light.stroke
    };
  `}
  ${props =>
    props.selected &&
    props.inverse &&
    `background-color: ${background.dark.selected};`}
  ${props =>
    props.selected && props.inverse && `color: ${background.dark.selected};`}
  ${props =>
    props.a11yFocus &&
    props.inverse &&
    `box-shadow: 0 0 0 2px ${focus.dark.stroke};`}
  ${props =>
    props.labelPosition &&
    `flex-direction: ${iconLabel.position[props.labelPosition]};`}
`;
